import StopWatch from "./stopWatch.service";

const stopWatchModule = angular
  .module("app.services.stopWatch", [])
  .service("StopWatch", StopWatch);

export default stopWatchModule;



// WEBPACK FOOTER //
// ./src/services/stopWatch/stopWatch.module.js